import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "utils";
import { CXL } from "@/components/Typography";
import Device from "@/utils/device";
import StepForwardTitle from "../step-forward/StepForwardTitle";
import MarketingButton from "../MarketingButton";

type SummitContentProps = {
  handleClick: (e) => void;
};

const SummitContent: FunctionComponent<SummitContentProps> = (props) => {
  return (
    <S.Section data-cy="SF-content-2023">
      <S.CopyContainer>
        <StepForwardTitle colour={colours.shell} uppercase>
          <b>
            <S.ItalicWrap>S</S.ItalicWrap>tep
          </b>{" "}
          <br />
          Forward <br />
          <S.FontWeightWrap>2025</S.FontWeightWrap>
        </StepForwardTitle>
        <CXL color={colours.shell} weight={700}>
          Mark your diaries for Friday 7th March 2025 at the Brewery, London -
          the UK’s biggest International Women’s Day event is back...
        </CXL>
        <MarketingButton
          name="access"
          buttonText="Secure your spot"
          colour={colours.shell}
          textColour={colours.shell}
          animationColour={colours.stepForwardBlue}
          onClick={props.handleClick}
        />
      </S.CopyContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  padding: 10% 10% 15% 10%;
  background-image: url(/images/step-forward-2025/dark-marble-background-landscape.png);
  background-repeat: no-repeat;
  background-size: cover;
  // background: ${colours.marketingBlue};
  display: flex;
  flex-direction: column;

  @supports not (-webkit-touch-callout: none) {
    background-attachment: fixed;
  }

  @media ${Device.tablet} {
    padding: 5% 10%;
  }
`;

S.FontWeightWrap = styled.span`
  font-weight: 100;
`;

S.CopyContainer = styled.div`
  margin: 30px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 20px;

  > ${CXL} {
    line-height: 2rem;
  }

  @media ${Device.mobile} {
    gap: 30px;

    > ${CXL} {
      line-height: 2.5rem;
    }
  }

  @media ${Device.desktop} {
    margin: 0 60px 0 0;
    gap: 40px;

    > ${CXL} {
      line-height: 2.8rem;
    }
  }
`;

S.ItalicWrap = styled.span`
  font-style: italic;
`;

S.BoldWrap = styled.span`
  font-weight: 700;
`;

export default SummitContent;
